import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import CustomMessage from './CustomMessage';

const SimpleTable = ({ columns, data, emptyMessage }) => {
  const [pageIndex, setPageIndex] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [pageArray, setPageArray] = useState([]);
  const [sort, setSort] = useState({});

  useEffect(() => {
    setPageCount(Math.ceil(data.length / 10));
  }, [data]);

  useEffect(() => {
    const sortedData = [...data];

    setPageArray(
      sortedData
        .sort((a, b) => {
          if (sort.desc) {
            return a[sort.key] > b[sort.key] ? -1 : 1;
          } else {
            return a[sort.key] < b[sort.key] ? -1 : 1;
          }
        })
        .slice((pageIndex - 1) * 10, pageIndex * 10)
    );
  }, [pageIndex, data, sort]);

  const handleSort = info => {
    if (info.length) {
      const { id, desc } = info[0];

      setSort({ key: id, desc });
    } else {
      setSort({});
    }
  };

  return (
    <>
      {pageArray.length ? (
        <AdvanceTableWrapper
          columns={columns}
          data={pageArray}
          pagination
          perPage={10}
          sortable
          manualSortBy
          onChangeSort={handleSort}
        >
          <AdvanceTable
            table
            headerClassName="bg-200 text-nowrap align-middle"
            rowClassName="align-middle text-black"
            tableProps={{
              bordered: true,
              striped: true,
              className: 'fs--1 mb-0 overflow-hidden border-light'
            }}
          />

          {pageCount > 1 ? (
            <AdvanceTablePagination
              pageIndex={pageIndex}
              pageCount={pageCount}
              limit={10}
              gotoPage={pageIndex => {
                setPageIndex(pageIndex + 1);
              }}
              canNextPage={pageIndex < pageCount}
              canPreviousPage={pageIndex > 1}
              nextPage={() => {
                setPageIndex(pageIndex + 1);
              }}
              previousPage={() => {
                setPageIndex(pageIndex - 1);
              }}
            />
          ) : (
            <div />
          )}
        </AdvanceTableWrapper>
      ) : (
        <CustomMessage
          ReactIcon={FaSearch}
          title={emptyMessage?.title || 'No se encontraron resultados'}
          message={
            emptyMessage?.message ||
            'No se encontraron resultados para la búsqueda realizada'
          }
        />
      )}
    </>
  );
};

SimpleTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  emptyMessage: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string
  })
};

export default SimpleTable;
